import React from 'react';
import { Link } from 'react-router-dom';
import logoWhite from '../assets/images/invertLogoWhite.png';

const FOOTER_COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Features', to: '/product' },
      { label: 'Applications', to: '/applications' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'For Business', to: '/for-business' },
      { label: 'Restaurant TV', to: '/restaurant-tv' },
    ],
  },
  {
    title: 'For Advertisers',
    links: [
      { label: 'Advertise', to: '/advertise' },
      { label: 'Our Network', to: '/network' },
      { label: 'Launch Campaign', to: '/launch' },
      { label: 'Advertiser Login', to: '/advertiserLogin/' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Proof', to: '/proof' },
      { label: 'Contact', to: '/contactUs' },
      { label: 'Terms of Service', to: '/tos' },
      { label: 'Screen Host Login', to: '/screenHostLogin/' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-invert-navy text-white border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/">
              <img src={logoWhite} alt="INVERT" className="h-8 w-auto mb-4" />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
              Restaurant TV content and restaurant TV box hardware for real venues.
            </p>
          </div>

          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-300 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-slate-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            &copy; {new Date().getFullYear()} INVERT. All rights reserved.
          </p>
          <p className="text-sm text-slate-500">
            Transform every screen into an intelligent business display.
          </p>
        </div>
      </div>
    </footer>
  );
}
